// extracted by mini-css-extract-plugin
module.exports = {"main":"page_main___Kcxz","mainTitle":"page_mainTitle__43mju","introText":"page_introText__yKrDx"};